module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("IMAGES OF WAR")]), _vm._v(" "), _c('p', {
    staticClass: "title1"
  }, [_vm._v("THE BEF IN 1917")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Arras, Vimy, Messines,")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("Passchendaele and Cambrai")]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_vm._v("RARE PHOTOGRAPHS FROM WARTIME ARCHIVES")]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_vm._v("BOB CARRUTHERS")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0